<!--
Copyright (c) 2020 ForgeRock. All rights reserved.

This software may be modified and distributed under the terms
of the MIT license. See the LICENSE file for details.
-->

<template>
    <b-alert show class="no-bg no-border">
        {{(isLinkingAccounts && apiType === 'reset') ? $t(`pages.selfservice.headers.${apiType}.linkingAccountsEmailSentMessage`) : $t(`pages.selfservice.headers.${apiType}.emailSent`)}}
    </b-alert>
</template>

<script>
/**
 * @description Selfservice stage for multiple selfservice flows, displays a email sent message
 *
 **/
export default {
    name: 'Email-Validation',
    props: {
        apiType: { required: true }
    },
    computed: {
        isLinkingAccounts () {
            return this.$route.query.isLinkingAccounts === 'true';
        }
    }
};
</script>

<style scoped>
.no-bg {
    background-color: transparent !important;
    font-weight: 400 !important;
    font-size: 16px !important;
    padding-left: 4px;
}
.no-border {
    border: none !important;
    font-weight: 400;
    font-size: 16px;
}
</style>
